import styled from "styled-components";

import Toggle from "src/organization/pages/project/environment/metrics/components/Toggle";

export const Layout = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
`;

export const Switch = styled(Toggle)``;
